import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const FISH = "#90a9b4";
const FISH_BELLY = "#d2dadd";
const FISH_FIN = "#5f7782";

function fishUnit(cx: number, cy: number, cz: number, s: number, flip: number): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(s, 0), color: FISH, position: [cx, cy, cz], scale: [1.7, 0.55, 0.8] as const },
    { geometry: new THREE.IcosahedronGeometry(s * 0.6, 0), color: FISH_BELLY, position: [cx - s * flip * 1.1, cy - s * 0.1, cz], scale: [0.9, 0.5, 0.7] as const },
    { geometry: new THREE.BoxGeometry(s * 0.5, s * 0.5, 0.01), color: FISH_FIN, position: [cx + s * flip * 1.5, cy + s * 0.1, cz], rotation: [0, 0, 0.5 * flip] },
  ];
}

export const fishCatch = defineModel({
  id: "fish-catch",
  batchId: "characters",
  name: "Fish catch",
  tags: ["good", "cargo", "food"],
  fits: ["carry"],
  summary: "A pair of fresh fish -- a carriable good for an avatar's carry socket.",
  description:
    "Two whole fish at held scale, ported from age-of-mcp's goods (`fish`). " +
    "Mount it in a player's or worker's `carry` socket to show the figure " +
    "hauling fish.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: (): Part[] => [
    ...fishUnit(0, 0.05, 0.02, 0.05, 1),
    ...fishUnit(0.0, 0.085, 0.0, 0.045, -1),
  ],
  animations: [],
});
